import API from "./api";

// GET ALL
export const getReservations = async () => {
  const res = await API.get("/reservations");
  return res.data;
};

// CREATE
export const createReservation = async (data) => {
  const res = await API.post("/reservations", data);
  return res.data;
};

// UPDATE
export const updateReservation = async (id, data) => {
  const res = await API.patch(`/reservations/${id}`, data);
  return res.data;
};

// DELETE
export const deleteReservation = async (id) => {
  const res = await API.delete(`/reservations/${id}`);
  return res.data;
};

export const downloadRentalDossierPdf = async (id) => {
  const res = await API.get(`/admin/reservations/${id}/dossier-pdf`, {
    responseType: "blob"
  });
  return res.data;
};
